/* @HEADER
 * @version 1.1.1422 | 2026-11-01
 * @purpose The three events that mean the page is leaving and what each says to the file backup (ZVX-DEV-8843): hiding is a page still alive, unloading is a page that is going.
 * @sidecar backupLeaveFlush.ts.header.md
 * @layer lib | @hex _none_ | @ctx backup
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-8843, ZVX-DEV-2257, ZVX-DEV-8035

/**
 * Why the page is leaving. `hidden`: `visibilitychange` to hidden, the page is still alive (a tab switch, or the first event of a
 * close), so the backup may collect by the worker. `unload`: `pagehide` or `beforeunload`, the page is going, and the worker may not
 * outlive it (ZVX-DEV-2254), so the backup writes on the main thread.
 */
export type LeaveCause = 'hidden' | 'unload'

/** Wires the three events to `flush`, saying which of the two causes each is. Never lets a failed flush out. */
export function installLeaveFlush(
  flush: (cause: LeaveCause) => Promise<void>,
  doc: Pick<Document, 'addEventListener' | 'visibilityState'>,
  win: Pick<Window, 'addEventListener'>,
): void {
  const run = (cause: LeaveCause) => () => void flush(cause).catch(() => {})
  doc.addEventListener('visibilitychange', () => {
    if (doc.visibilityState === 'hidden') run('hidden')()
  })
  win.addEventListener('pagehide', run('unload'))
  win.addEventListener('beforeunload', run('unload'))
}
